// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__f3+CN","divide":"style_divide__qlAso"};